module.exports = "/_next/static/images/0c8b8beb8ae6d7df2c30e7d0c86c5b28-man-looking-up-smiling-xs@2x.jpg.webp";